import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { SearchData } from 'src/app/services/searchData';
import { TourService } from 'src/app/services/TourService';
import { MessagemodelComponent } from './../../../components/messagemodel/messagemodel.component';
import { ApiService } from './../../../services/api.service';
import { CommonValues } from './../../../services/commonValues';
import { UserBadgeComponent } from '../../../components/landing-page/user-badge/user-badge.component';
import { NewNavBarComponent } from '../../homepage/new-nav-bar/new-nav-bar.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { NotifierComponent } from '../../../templates/notifier/notifier.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { HomeTabStateService } from '../../../features/dashboards/home-tab-state.service';

declare var $: any;

@Component({
  selector: 'app-index-layout',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterOutlet, UserBadgeComponent, NewNavBarComponent, CommonSkeletonComponent, MessageWidgetComponent, NotifierComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './index-layout.component.html',
  styleUrls: ['./index-layout.component.scss']
})
export class IndexLayoutComponent implements OnInit, OnDestroy {
  userDetailsLanding: any = [];
  userId;
  divHeight
  //Dev Code
  @ViewChild('landingside1') menuElement: ElementRef;
  @ViewChild('landingside2') menuElement1: ElementRef;

  landingsidesticky1: boolean = true;
  landingsidesticky2: boolean = false;
  csshide:Boolean=false
  elementPosition: any;
  bsModalRef: BsModalRef;
  messageData:any = {};
  messagemodelflag:Boolean=false;
  totalmsgcount: Subscription;
  connectionSubScription : Subscription;
  totalMsgCount: number = 0;
  loadAPIcall:boolean=false;
  tourSteps: any[] = [];
  private tourCompletedSub: Subscription;

  /**
   * Legacy flag — kept only to avoid breaking existing template expressions
   * (`*ngIf="showSideBadge"`, `[class.full-width-dash]="!showSideBadge"`).
   * The Activity Feed profile badge is now rendered by LandingPageComponent
   * inside its own three-column grid, so this layout never shows the side
   * rail anymore.
   */
  showSideBadge: boolean = false;

  constructor(private API: ApiService,private tourService: TourService, private commonvalues: CommonValues,private searchData : SearchData,private modalService: BsModalService, private route: ActivatedRoute, private homeTabs: HomeTabStateService) {

    this.homeTabs.activeTab$.subscribe(tab => {
      // Always false now — see the note above. Subscription kept to avoid
      // surprising future readers who expect the service to still drive state.
      this.showSideBadge = false;
    });


    this.commonvalues.getMsgCount().subscribe(count => {
      this.totalMsgCount = count;
    });

    this.tourService.getTourSteps('LandingPage').subscribe(data => {
      this.tourSteps = data;
    });

    // Note: Backup email prompt is now handled by langding-page-nav-bar component
    // to avoid duplicate prompts when tour completes

    this.connectionSubScription = this.searchData.getContactCount().subscribe(res=>{
      if(res){
         this.messageData  = {
          userId : localStorage.getItem('userId'),
          id : null,
          removeConnection : true,
          owner : true,
         };
      }
    });
   }

  ngOnInit() {
    this.loadAPIcall=true
    setTimeout(() => {
      this.loadAPIcall=false;
    }, 2000);
    if(window.innerHeight==500 && window.innerWidth==1093){
      this.csshide=true;
    } else if(window.innerHeight>500 && window.innerWidth>1093){
      this.csshide=true;
    } else if(window.innerHeight<500 && window.innerWidth<1093){
      this.csshide=true;
    }

    this.userId = localStorage.getItem('userId');

    // Check for secondary email prompt for JOB_SEEKER users on first page load
    // Since they don't get the tour, we need to trigger the check manually
    const userType = localStorage.getItem('userType');
    
    if (userType === 'JOB_SEEKER') {
      setTimeout(() => {
        this.checkSecondaryMailCheck();
      }, 500);
    }

    // Note: Backup email prompt is now handled by langding-page-nav-bar component
    // to avoid duplicate prompts when tour completes
   }


   getTourData(stepId: string,key:string): string {
    const step = this.tourSteps.find(s => s.stepId === stepId);
    return step ? step[key] : 'Loading...';
  }

  ngAfterViewInit(){
    window.scrollTo(0, 0);
   // this.elementPosition = this.menuElement.nativeElement.offsetTop;
   }

  @HostListener('window:scroll')
    handleScroll(){
      const windowScroll = window.pageYOffset;
      if(windowScroll >= 24){
        // this.landingsidesticky1 = true;
        this.landingsidesticky2 = true;

      } else {
        // this.landingsidesticky1 = false;
        this.landingsidesticky2 = false;
      }
    }

    @HostListener("window:resize")
    onResize() {
         if(window.innerHeight==500 && window.innerWidth==1093){
          //this.landingsidesticky1 = false;
          //this.landingsidesticky2 = true;
          this.csshide=true;
        }else  if(window.innerHeight>500 && window.innerWidth>1093){
          //this.landingsidesticky1 = false;
         // this.landingsidesticky2 = true;
          this.csshide=true;
        }else  if(window.innerHeight<500 && window.innerWidth<1093){
          this.csshide=false;
        }
     }

     modelopen() {
      const initialState: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        size: 'xl',
      };
      this.bsModalRef = this.modalService.show(MessagemodelComponent, initialState);
      this.bsModalRef.content.closeBtnName = 'Close';
    }



  chatbottom() {
    let seletedItem:any={};
    // this._socket.ngOnDestroy();
    // this._socket.connections();
    // this._socket.connections_stream();

    seletedItem.owner=true;
    this.messagemodelflag=true;
    seletedItem.userId = localStorage.getItem('userId');
    seletedItem.id = null;
    // Marks the floating bottom chat specifically. Only this entry point also
    // loads the direct USER-to-USER contacts (message/new/contact/{userId}) and
    // merges them into the list. Other chat icons (cards, sliders, nav-bar, etc.)
    // open the same widget in owner mode but must keep the single-API behaviour.
    seletedItem.bottomChat = true;
    this.messageData = seletedItem;


  }
  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
    // this._socket.connections_stream();

  }

  notificationTitle: string = "";
  notificationContent: string = "";
  showSecondaryAlert: boolean = false;
  checkSecondaryMailCheck() {
    const tourPending = this.tourService.isLandingTourPending();
    console.log('[IndexLayout] checkSecondaryMailCheck', {
      backupEmailPromptShown: this.tourService.hasShownBackupEmailPrompt(),
      tourPending,
    });
    if (this.tourService.hasShownBackupEmailPrompt()) {
      console.log('[IndexLayout] checkSecondaryMailCheck skipped - already shown');
      return;
    }
    console.log('[IndexLayout] calling home/checkSecondaryIsNonGenericMail');
    this.API.query("home/checkSecondaryIsNonGenericMail").subscribe((res) => {
      console.log('[IndexLayout] checkSecondaryIsNonGenericMail response', res);
      if (res && res.data && res.data.show) {
        this.tourService.markBackupEmailPromptShown();
        this.notificationTitle = res.data.isSecondaryNull ? "Add a Backup Email" : "Add a Backup Email"
        this.notificationContent = res.data.isSecondaryNull ?
        "Secondary email address is missing in your profile. It is mandatory to maintain your account on the platform. Please update your profile with a secondary email address."
         : "Please change your secondary email address to a generic one (Hotmail, Gmail etc) in the profile";
        this.showSecondaryAlert = false;
        setTimeout(() => {
          console.log('[IndexLayout] showing backup email popup');
          this.showSecondaryAlert = true;
        }, 0);
      } else {
        console.log('[IndexLayout] API says do not show backup email popup');
      }
    }, (err) => {
      console.error('[IndexLayout] checkSecondaryIsNonGenericMail error', err);
    });

  }

  ngOnDestroy() {
    this.tourCompletedSub?.unsubscribe();
    this.connectionSubScription?.unsubscribe();
    this.totalmsgcount?.unsubscribe();
  }

}
